import { graphql } from 'gql.tada';
import { client } from '../client';

export const getRefundOptionsQuery = graphql(`
  query RefundOptions($input: RefundOptionsInput!) {
    refundOptions(input: $input) {
      estimateBreakdown {
        label
        formattedDisplay
        monetaryValue {
          value
          formattedString
          currency
        }
        type
        category
      }
      payment {
        clientSecret
        id
        isPreCharge
      }
      type
    }
  }
`);

export const getRefundOptionsQueryFn = async (
  input: RefundOptionsVariables['input'],
) => {
  return await client.request(getRefundOptionsQuery, { input });
};

/* eslint-disable typescript/no-explicit-any -- Required for gql.tada type inference */
export type RefundOptionsVariables =
  typeof getRefundOptionsQuery extends import('gql.tada').TadaDocumentNode<
    any,
    infer T,
    any
  >
    ? T
    : never;
/* eslint-enable typescript/no-explicit-any */

export type CartItemInputVariables =
  RefundOptionsVariables['input']['cart']['refund'];

export type RefundResult = Awaited<ReturnType<typeof getRefundOptionsQueryFn>>;
export type RefundOption = RefundResult['refundOptions'][number];
export type EstimateBreakdown = RefundOption['estimateBreakdown'];
export type MonetaryValue = NonNullable<
  EstimateBreakdown[number]['monetaryValue']
>;
